import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGeneratorHeroCard from '../components/ResponseBlockGeneratorHeroCard';
import { gAPI_Response_AssistantOptions } from '../../../../../constants/APIs';

export default class AssistantOptions extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGeneratorHeroCard getUrl={gAPI_Response_AssistantOptions} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
